import api from './api'
import store from '@/store'
import moment from 'moment'
import CallHelper from '@/helpers/call.helper'

class UnavailabilityService {
    async get(params = {}) {
        return api.get('/account/' + store.state.account.uuid + '/unavailability', {'params': params}).then(response => response.data);
    }

    async get(params = {}) {
        return CallHelper.getDataRecursive(
            '/account/' + store.state.account.uuid + '/unavailability',
            params,
            (data, response) => {

                if(data['unavailabilities']) {
                    data['unavailabilities'] = [...data['unavailabilities'], ...response.data.unavailabilities]
                } else {
                    data['unavailabilities'] = response.data.unavailabilities
                }

                if(data['unavailabilities_weekly']) {
                    data['unavailabilities_weekly'] = [...data['unavailabilities_weekly'], ...response.data.unavailabilities_weekly]
                } else {
                    data['unavailabilities_weekly'] = response.data.unavailabilities_weekly
                }

                return data
            },
        )
    }

    async create(unavailability, account) {
        return api.post('/account/' + store.state.account.uuid + '/unavailability',  {
            account_uuid: account,
            date: moment(unavailability.date).format('YYYY-MM-DD'),
            time: unavailability.time.hours.toString().padStart(2, '0') + ':' + unavailability.time.minutes.toString().padStart(2, '0') + ':00',
            duration: unavailability.duration,
            reason_id: unavailability.reason_id,
            weekly: unavailability.weekly ? unavailability.weekly : false,
        })
        .then(response => response.data);
    }

    async modify(unavailability) {
        if(unavailability.date instanceof Date)
        {
            unavailability.date = moment(unavailability.date).format('YYYY-MM-DD')
        }

        return api
            .patch('/account/' + store.state.account.uuid + '/unavailability/' + unavailability.id, {
                date: unavailability.date,
                time: unavailability.time.hours.toString().padStart(2, '0') + ':' + unavailability.time.minutes.toString().padStart(2, '0') + ':00',
                duration: unavailability.duration,
                reason_id: unavailability.reason_id,
            })
            .then(response => response.data);
    }

    async delete(unavailabilityId) {
        return api.delete('/account/' + store.state.account.uuid + '/unavailability/' + unavailabilityId).then(response => response.data);
    }

    async createWeekly(unavailability, account) {
        return api.post('/account/' + store.state.account.uuid + '/unavailability-weekly',  {
            account_uuid: account,
            day: unavailability.day,
            time: unavailability.time.hours.toString().padStart(2, '0') + ':' + unavailability.time.minutes.toString().padStart(2, '0') + ':00',
            duration: unavailability.duration,
            reason_id: unavailability.reason_id,
            weekly: unavailability.weekly ? unavailability.weekly : false,
        })
        .then(response => response.data);
    }

    async modifyWeekly(unavailability) {
        return api
            .patch('/account/' + store.state.account.uuid + '/unavailability-weekly/' + unavailability.id, {
                day: unavailability.day,
                time: unavailability.time.hours.toString().padStart(2, '0') + ':' + unavailability.time.minutes.toString().padStart(2, '0') + ':00',
                duration: unavailability.duration,
                reason_id: unavailability.reason_id,
            })
            .then(response => response.data);
    }

    async getReasons(params = {}) {
        return api.get('/account/' + store.state.account.uuid + '/unavailability-reason', {'params': params}).then(response => response.data);
    }

    async removeReason(reasonId) {
        return api.delete('/account/' + store.state.account.uuid + '/unavailability-reason/' + reasonId).then(response => response.data);
    }
}

export default new UnavailabilityService();
